export const GET_ERRORS = 'GET_ERRORS';

export const CREATE_MESSAGE = 'CREATE_MESSAGE';

export const BEGIN_LOADING = 'BEGIN_LOADING';
export const END_LOADING = 'END_LOADING';

export const REDIRECT_TO = 'REDIRECT_TO';